import { MGPOptional } from '@everyboard/lib';
import { BooleanConfig } from '../../../config/BooleanConfig';
import { RulesConfigDescription } from '../../../config/RulesConfigDescription';
import { TaflPawn } from '../TaflPawn';
import { TaflNode, TaflRules } from '../TaflRules';
import { TaflState } from '../TaflState';
import { HnefataflMove } from './HnefataflMove';
export class HnefataflNode extends TaflNode {
}
export class HnefataflRules extends TaflRules {
    static singleton = MGPOptional.empty();
    static RULES_CONFIG_DESCRIPTION = new RulesConfigDescription({
        name: () => $localize `Hnefatafl`,
        config: {
            canReturnToCastle: new BooleanConfig(true, TaflRules.CAN_RETURN_TO_CASTLE),
            edgesAreKingsEnnemy: new BooleanConfig(true, TaflRules.EDGE_ARE_KING_S_ENNEMY),
            centralThroneCanSurroundKing: new BooleanConfig(false, TaflRules.CENTRAL_THRONE_CAN_SURROUND_KING),
            kingFarFromHomeCanBeSandwiched: new BooleanConfig(false, TaflRules.KING_FAR_FROM_HOME_CAN_BE_SANDWICHED),
            invaderStarts: new BooleanConfig(true, TaflRules.INVADER_STARTS),
        },
    });
    static get() {
        if (HnefataflRules.singleton.isAbsent()) {
            HnefataflRules.singleton = MGPOptional.of(new HnefataflRules());
        }
        return HnefataflRules.singleton.get();
    }
    constructor() {
        super(HnefataflMove.from);
    }
    getInitialState(config) {
        const _ = TaflPawn.UNOCCUPIED;
        let I = TaflPawn.PLAYER_ZERO_PAWN;
        let D = TaflPawn.PLAYER_ONE_PAWN;
        let K = TaflPawn.PLAYER_ONE_KING;
        if (config.invaderStarts === false) {
            I = TaflPawn.PLAYER_ONE_PAWN;
            D = TaflPawn.PLAYER_ZERO_PAWN;
            K = TaflPawn.PLAYER_ZERO_KING;
        }
        const board = [
            [_, _, _, I, I, I, I, I, _, _, _],
            [_, _, _, _, _, I, _, _, _, _, _],
            [_, _, _, _, _, _, _, _, _, _, _],
            [I, _, _, _, _, D, _, _, _, _, I],
            [I, _, _, _, D, D, D, _, _, _, I],
            [I, I, _, D, D, K, D, D, _, I, I],
            [I, _, _, _, D, D, D, _, _, _, I],
            [I, _, _, _, _, D, _, _, _, _, I],
            [_, _, _, _, _, _, _, _, _, _, _],
            [_, _, _, _, _, I, _, _, _, _, _],
            [_, _, _, I, I, I, I, I, _, _, _],
        ];
        return new TaflState(board, 0);
    }
    getRulesConfigDescription() {
        return HnefataflRules.RULES_CONFIG_DESCRIPTION;
    }
}
